import { state } from './state';
import { versions } from './versions';

export const encoders = {
  state: {
    ...state,
  },
  versions: {
    ...versions,
  },
};
